module.exports = __webpack_public_path__ + "img/banner_03.00464259.png";